import moment from 'moment';

export function formatDateISO(d: Date): string {
  return moment(d).format('YYYY-MM-DD');
}

export function parseDateISO(str: string): Date {
  return moment(str, 'YYYY-MM-DD').toDate();
}

export function todayISO(): string {
  return moment().format('YYYY-MM-DD');
}

export function toDateISO(year: number, month: number, day: number): string {
  return moment({ year, month, day }).format('YYYY-MM-DD');
}

export function formatDateShort(dateStr: string): string {
  const m = moment(dateStr, 'YYYY-MM-DD');
  return m.isValid() ? m.format('D MMM') : dateStr;
}

export function formatDateWithWeekday(dateStr: string): string {
  const m = moment(dateStr, 'YYYY-MM-DD');
  return m.isValid() ? m.format('ddd, D MMM') : dateStr;
}

export function formatDisplayDate(dateStr: string): string {
  const m = moment(dateStr, 'YYYY-MM-DD');
  return m.isValid() ? m.format('D MMM YYYY') : dateStr;
}
